export const INITIAL_TOKEN = 'initial_token';
export const ACCESS_TOKEN = 'access_token';
export const CLIENTS = 'clients';
export const CLIENT_ID = 'client_id';
export const INITIAL_TOKEN_STAGE_PRE = '2fa-process';
export const INITIAL_TOKEN_STAGE_MFA = 'trust-choice';
export const INITIAL_TOKEN_STAGE_CLIENT = 'client-choice';
export const TRUST_CHOICE = 'trust-choice';
export const SU_MANAGEMENT = 'su-management';
export const AUTH_LOGIN_ERROR = 'Username or password incorrect';
export const AUTH_USERNAME = 'userName';
export const AUTH_EMPLOYEEID = 'employeeId';
export const AUTH_IS_TRAINING_ENABLE = 'IsTrainingEnable';


